module.exports = __webpack_public_path__ + "static/media/a4c-screen.161c9f60.jpg";